/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-unused-vars */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-alert */
/* eslint-disable no-param-reassign */
/* eslint-disable no-restricted-syntax */
/* eslint-disable import/no-cycle */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useRef, useState, useEffect } from 'react';
import { DialogUtility } from '@syncfusion/ej2-popups';
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Page,
  Selection,
  Inject,
  Edit,
  Toolbar,
  Resize,
  Sort,
  Filter,
  Search,
  ForeignKey,
  Group,
  LazyLoadGroup,
  PdfExport,
  ExcelExport,
} from '@syncfusion/ej2-react-grids';
import { useNavigate } from 'react-router-dom';
import { AccordionComponent } from '@syncfusion/ej2-react-navigations';
import { DialogComponent } from '@syncfusion/ej2-react-popups';

import { MultiSelectComponent, DropDownListComponent, CheckBoxSelection } from '@syncfusion/ej2-react-dropdowns';
import { TextBoxComponent, UploaderComponent } from '@syncfusion/ej2-react-inputs';
import { ButtonComponent, CheckBoxComponent, RadioButtonComponent } from '@syncfusion/ej2-react-buttons';
import { Query } from '@syncfusion/ej2-data';
import { Header } from '../components';
import profile from '../data/profile.png';
import './Zackat.css';

const Manager = () => {
  const navigate = useNavigate();
  let usr = localStorage.getItem('user');
  let selectedOrg = localStorage.getItem('organization');
  if (!usr || !selectedOrg) {
    // Redirect
    navigate('/login?landing=managers');
    return <p>Please login... </p>;
  }
  usr = JSON.parse(usr);
  selectedOrg = JSON.parse(selectedOrg);
  const [selAnAssociate, setAnAssociate] = useState('');
  const [associateContent, setAssociateContent] = useState('');
  const [enableInvite, setInvite] = useState(true);
  const orgData = [];
  const multilineAttributes = {
    rows: 4, // Sets the initial visible number of lines to 4
  };

  const invite = { text: 'Invite', tooltipText: 'MobileApp Invitation', prefixIcon: 'e-resize', id: 'invite', disabled: enableInvite };
  const add = { text: 'Add', tooltipText: 'Add Associate', prefixIcon: 'e-add', id: 'add', disabled: false };
  const toolbarOptions = [invite, add, 'PdfExport', 'ExcelExport', 'Search'];
  const { REACT_APP_API_ENDPOINT } = process.env;
  const valuerules = { required: true };
  const valuerulesnot = { required: false };
  const fields = { value: '_id', text: 'name' };
  const grid = useRef(null);
  const dialogRef = useRef(null);

  const [reload, setReload] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [groups, setGroups] = useState([]);
  const [sortOptions, setSortColumns] = useState({});
  const [selUploadOrganization, setUploadOrganization] = useState('');
  const [managerid, setManagerId] = useState('');
  const [smsOptin, setSMSOptin] = useState(false);
  const [emailOptin, setEmailOptin] = useState('');
  const [dataChanged, setDataChanged] = useState(false);
  const [crudUpdate, setCrudUpdate] = useState(false);
  const [crudCreate, setCrudCreate] = useState(false);
  const [crudDelete, setCrudDelete] = useState(false);
  useEffect(() => {
    if (data.role && data.role.associates && data.role.associates.permissions.includes('Create')) {
      setCrudCreate(true);
    }
    if (data.role && data.role.associates && data.role.associates.permissions.includes('Update')) {
      setCrudUpdate(true);
    }
    if (data.role && data.role.associates && data.role.associates.permissions.includes('Delete')) {
      setCrudDelete(true);
    }
  }, [data]);

  const dialogButtons = [{
    click: () => {
      dialogRef.current.hide();
    },
    buttonModel: { content: 'OK', isPrimary: true },
  }];

  const [selFirstName, setFirstName] = useState('');
  const [selLastName, setLastName] = useState('');
  const [selAssociates, setAssociates] = useState('');
  const [selOrganization, setOrganization] = useState('');
  const [selEmployeeImage, setEmployeeImage] = useState('');
  const [selMobile, setMobile] = useState('');
  const [selEmail, setEmail] = useState('');
  const [manager, setManager] = useState(null);
  const [selAddress, setAddress] = useState('');
  const [selAddress1, setAddress1] = useState('');
  const [selCity, setCity] = useState('');
  const [selState, setState] = useState('');
  const [selZip, setZip] = useState('');

  useEffect(() => {
    // limit associates to the overall selection
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    usr.limit = 1;
    // fetch data
    const managerFetch = async () => {
      if (managerid !== '' && managerid !== 'add_manager') {
        const query = Object.entries(usr)
          .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
          .join('&');
        const url = `${REACT_APP_API_ENDPOINT}/managers?${query}&managerid=${managerid}&abbrev=true`;
        if (!usr.loggedIn) {
          navigate('/login');
          return;
        }
        const mydata = await (
          await fetch(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `JWTToken ${usr.token}`,
            },
          })
        ).json();
        let associates = '';
        if (mydata) {
          setFirstName(`${mydata.managers[0].first ? mydata.managers[0].first : ''}`);
          setLastName(`${mydata.managers[0].last ? mydata.managers[0].last : ''}`);
          setMobile(`${mydata.managers[0].mobile ? mydata.managers[0].mobile : ''}`);
          setEmail(`${mydata.managers[0].email ? mydata.managers[0].email : ''}`);
          setAddress(mydata.managers[0].address ? mydata.managers[0].address : '');
          setAddress1(mydata.managers[0].address1 ? mydata.managers[0].address1 : '');
          setCity(mydata.managers[0].city ? mydata.managers[0].city : '');
          setState(mydata.managers[0].state ? mydata.managers[0].state : '');
          setZip(mydata.managers[0].zip ? mydata.managers[0].zip : '');
          setOrganization(mydata.managers[0].organizationid ? mydata.managers[0].organizationid : null);
          if (mydata.managers[0].image && mydata.managers[0].image.includes(mydata.managers[0]._id)) {
            const tm = new Date().getTime();
            setEmployeeImage(`${mydata.managers[0].image}&key=${tm}`);
          } else {
            setEmployeeImage('https://monaco.zackat.com/blank.png');
          }
          if (mydata.managers[0].associatenames) {
            // eslint-disable-next-line no-return-assign
            mydata.managers[0].associatenames.map((item) => (
              associates += `${item}\r\n`
            ));
          }
        }
        setAssociates(associates);
        setManager(mydata.managers[0]);
      }
    };

    managerFetch();
  }, [managerid, reload]);

  const groupOptions = {
    enableLazyLoading: false,
    columns: groups,
  };

  useEffect(() => {
    // limit associates to the overall selection
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    // fetch data
    const dataFetch = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/managers?${query}&abbrev=true`;
      const mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json();
      if (mydata.user && mydata.user.preferences && mydata.user.preferences.managers) {
        if (mydata.user.preferences.managers.group) {
          setGroups(mydata.user.preferences.managers.group);
        } else {
          setGroups(['organizationid']);
        }
        if (mydata.user.preferences.managers.sort && mydata.user.preferences.managers.sort[0].direction) {
          const mysortedColumns = { columns: mydata.user.preferences.managers.sort };
          setSortColumns(mysortedColumns);
        }
      } else {
        setGroups(['organizationid']);
      }
      // set state when the data received
      setData(mydata);
      setLoading(false);
    };
    dataFetch();
  }, [reload]);

  function handleChange(e) {
    let upData = null;
    for (let idx = 0; idx < data.managers.length; idx += 1) {
      if (data.managers[idx]._id === e.target.id) {
        upData = data.managers[idx];
        break;
      }
    }
    const filedata = new FormData();
    const imagedata = e.target.files[0];
    filedata.append('userfile', imagedata);
    if (upData !== null) {
      filedata.append('_id', upData._id);
      filedata.append('fileName', e.target.files[0].name);
    } else {
      return;
    }
    fetch(`${REACT_APP_API_ENDPOINT}/mfileup`, {
      method: 'POST',
      headers: {
        Authorization: `JWTToken ${usr.token}`,
      },
      body: filedata,
    })
      .then((response) => response.json())
      .then((responseJson) => {
        // window.location.reload();
        setReload(!reload);
      })
      .catch((error) => {
        DialogUtility.alert('An error has occured during Insert!');
      });
  }
  const clickHandler = (args) => {
    if (grid && grid.current && args.item.properties.text === 'Invite') {
      const selectedRecords = grid.current.getSelectedRecords();
      const recipient = prompt('Please enter the email address of the Manager that you would like to receive the invitation!', selectedRecords[0].email);
      if (recipient) {
        fetch(`${REACT_APP_API_ENDPOINT}/invite?associateid=${selectedRecords[0]._id}&manager=true&recipient=${recipient}&email=${usr.email}`, {
          method: 'GET',
          headers: {
            Authorization: `JWTToken ${usr.token}`,
          },
        })
          .then((response) => response.json())
          .then((responseJson) => {
            if (responseJson && responseJson.response && responseJson.response !== 'OK') {
              args.cancel = true;
              DialogUtility.alert(responseJson.response);
            }
          })
          .catch((error) => {
            DialogUtility.alert('An error has occured during Invitation request!');
            args.cancel = true;
          });
      }
    } else if (grid && grid.current && args.item.properties.text === 'PDF Export') {
      const properties = {
        fileName: `PDFExport_Manager_${new Date().toISOString()}.pdf`,
        pageOrientation: 'Landscape',
      };
      grid.current.pdfExport(properties);
    } else if (grid && grid.current && args.item.properties.text === 'Excel Export') {
      const properties = {
        fileName: `ExcelExport_Manager_${new Date().toISOString()}.xlsx`,
      };
      grid.current.excelExport(properties);
    } else if (grid.current && args.item.properties.text === 'Add') {
      setFirstName('');
      setLastName('');
      setMobile('');
      setEmail('');
      setAddress('');
      setAddress1('');
      setCity('');
      setState('');
      setZip('');
      setSMSOptin(false);
      setEmailOptin(false);
      setEmployeeImage('https://monaco.zackat.com/blank.png');
      setOrganization(null);
      setManager(null);
      setManagerId('add_manager');
    }
  };
  function removePhoto(e) {
    let removeData = null;
    for (let idx = 0; idx < data.managers.length; idx += 1) {
      if (data.managers[idx]._id === e.target.id) {
        removeData = data.managers[idx];
        break;
      }
    }
    if (removeData == null || confirm(`Remove photo for ${removeData.first} ${removeData.last}?`) === false) {
      return;
    }
    if (removeData !== null) {
      fetch(`${REACT_APP_API_ENDPOINT}/mfileup`, {
        method: 'DELETE',
        headers: {
          Authorization: `JWTToken ${usr.token}`,
        },
        body: JSON.stringify(removeData),
      })
        .then((response) => response.json())
        .then((responseJson) => {
          if (responseJson && responseJson.response && responseJson.response !== 'OK') {
            DialogUtility.alert(responseJson.response);
          }
          setReload(!reload);
          // window.location.reload();
        })
        .catch((error) => {
          DialogUtility.alert('An error has occured during Removal!');
        });
    }
  }
  const customerGridImage = (props) => (
    <div className="image flex gap-4">
      {!props.image
        ? <input type="file" name="userfile" id={props._id} onChange={handleChange} />
        : (
          <div>
            <img
              className="rounded-full w-10 h-10"
              src={props.image && props.image.length > 0 ? props.image : profile}
              alt="employee"
            />
            <font color="black"><input type="submit" name="remove" id={props._id} value="&#x007F;" onClick={removePhoto} /></font>
          </div>
        )}
    </div>
  );
  const cancelProfile = () => {
    setManagerId('');
    setOrganization('');
  };

  const removeAssociate = () => {
    usr.limit = 1;
    usr.associate = selAnAssociate;
    const query = Object.entries(usr)
      .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
      .join('&');
    const url = `${REACT_APP_API_ENDPOINT}/managers?abbrev=true&action=remove&associate=${selAnAssociate}&managerid=${managerid}`;

    fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(usr),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        // The added/edited data will be saved in the Grid
        // The default edit operation is cancelled
        setAssociateContent(responseJson.response);
      })
      .catch(() => {
        DialogUtility.alert('An error has occured during Associate Find!');
      });
  };

  const lookupAssociate = () => {
    usr.limit = 1;
    usr.associate = selAnAssociate;
    const query = Object.entries(usr)
      .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
      .join('&');
    const url = `${REACT_APP_API_ENDPOINT}/managers?abbrev=true&action=add&associate=${selAnAssociate}&managerid=${managerid}`;

    fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(usr),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        // The added/edited data will be saved in the Grid
        // The default edit operation is cancelled
        setAssociateContent(responseJson.response);
      })
      .catch((error) => {
        console.error(error);
        DialogUtility.alert('An error has occured during Associate Find!');
      });
  };
  const saveProfile = () => {
    if (manager.organizationid !== selOrganization) {
      const result = orgData.find(({ id }) => id === selOrganization);
      if (!confirm(`Would you like to move this Manager ${manager.name} from ${manager.organization} to ${result.value}`)) {
        return;
      }
      manager.organizationid = selOrganization;
      manager.organization = result.value;
    }
    if (selFirstName.length === 0) {
      DialogUtility.alert('Please provide a first name for the Manager');
      return;
    }
    if (selEmail.length > 0 && !selEmail.includes('@') && !selEmail.includes('.')) {
      DialogUtility.alert('Please provide a valid device for the Manager');
      return;
    }
    manager.first = selFirstName;
    manager.last = selLastName;
    manager.mobile = selMobile;
    manager.email = selEmail;
    manager.address = selAddress;
    manager.address1 = selAddress1;
    manager.city = selCity;
    manager.state = selState;
    manager.zip = selZip;
    fetch(`${REACT_APP_API_ENDPOINT}/managers`, {
      method: 'UPDATE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(manager),
    })
      .then((response) => response.json())
      .then(() => {
        // The added/edited data will be saved in the Grid
        // The default edit operation is cancelled
        DialogUtility.alert('Profile saved');
      })
      .catch((error) => {
        DialogUtility.alert('An error has occured during Update!');
      });
  };
  const addProfile = () => {
    const result = orgData.find(({ id }) => id === selOrganization);
    const newmanager = {};
    newmanager.organizationid = selOrganization;
    newmanager.organization = result.value;
    newmanager.first = selFirstName;
    newmanager.last = selLastName;
    newmanager.mobile = selMobile;
    newmanager.email = selEmail;
    newmanager.address = selAddress;
    newmanager.address1 = selAddress1;
    newmanager.city = selCity;
    newmanager.state = selState;
    newmanager.zip = selZip;
    fetch(`${REACT_APP_API_ENDPOINT}/managers`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(newmanager),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        // The added/edited data will be saved in the Grid
        if (responseJson && responseJson._id) {
          newmanager._id = responseJson._id;
          setManagerId(newmanager._id);
        }
        if (responseJson && responseJson.response && responseJson.response !== 'OK') {
          DialogUtility.alert(responseJson.response);
        }
        setReload(!reload);
      })
      .catch((error) => {
        DialogUtility.alert('An error has occured during New Associate Insert!');
      });
  };
  useEffect(() => {
    if (dialogRef && dialogRef.current && associateContent.length > 0) {
      dialogRef.current.show(); // Show dialog if no row is selected
      if (associateContent.includes('OK'));
      setReload(!reload);
      setAssociateContent('');
    }
  }, [associateContent]);

  useEffect(() => {
    if (grid && grid.current) {
      setInvite(false);
      const selectedRecords = grid.current.getSelectedRecords();
      if (selectedRecords && selectedRecords.length === 1) {
        if (selectedRecords.length > 0) {
          setManagerId(selectedRecords[0]._id);
        } else {
          setManagerId('');
          setInvite(true);
        }
      } else {
        setManagerId('');
        setInvite(true);
      }
    }
  }, [dataChanged]);

  function rowClicked() {
    setDataChanged(!dataChanged);
  }
  if (loading) {
    return <p>Loading... </p>;
  }
  if (data.organization && data.organization.length > 0) {
    data.organization.forEach((org) => {
      orgData.push({ id: org._id, value: org.title });
    });
  }
  const associateDatasource = [];
  if (data.associates && data.associates.length > 0) {
    data.associates.forEach((associate) => {
      associateDatasource.push({ _id: manager._id, name: manager.name });
    });
  }
  const organizations = {
    params: {
      actionComplete: () => false,
      allowFiltering: true,
      dataSource: data.organization,
      fields: { value: '_id', text: 'title' },
      query: new Query(),
    },
  };
  const roles = {
    params: {
      actionComplete: () => false,
      allowFiltering: true,
      dataSource: data.roles,
      fields: { value: '_id', text: 'name' },
      query: new Query(),
    },
  };

  const associates = {
    params: {
      actionComplete: () => false,
      allowFiltering: true,
      dataSource: associateDatasource,
      fields: { value: '_id', text: 'name' },
      query: new Query(),
    },
  };
  let assocRef;
  const associateTemplate = (props) => (
    <div>
      <label>Associates</label>
      <MultiSelectComponent
        id={props._id}
        ref={(scope) => { assocRef = scope; }}
        dataSource={associateDatasource}
        mode="CheckBox"
        fields={fields}
        value={props.associates}
      >
        <Inject services={[CheckBoxSelection]} />
      </MultiSelectComponent>
    </div>
  );
  const actionComplete = (args) => {
    const editedData = args.data;
    const cols = grid.current.columns;
    for (const col of cols) {
      if (col.headerText === 'Associates' || col.headerText === 'Image') {
        col.visible = true;
      }
    }
    if (assocRef && assocRef.value) {
      editedData.associates = assocRef.value;
    }

    /** Set initial Focus */
    if (args.requestType === 'beginEdit') {
      args.form.elements.namedItem('first').focus();
      // eslint-disable-next-line prefer-destructuring
      const dialog = args.dialog;
      dialog.header = `Details of ${args.rowData.first} ${args.rowData.last}`;
    } else if (args.requestType !== 'save' && args.form && args.requestType === 'add') {
      args.form.elements.namedItem('first').focus();
    } else if (args.requestType === 'save' && args.action === 'add') {
      if (args.data) {
        // Here you can send the updated data to your server using AJAX call
        orgData.forEach((element) => {
          if (element.id === editedData.organizationid) {
            editedData.organizationid = element.id;
            editedData.organization = element.value;
          }
        });
        if (confirm('Add this manager?')) {
          fetch(`${REACT_APP_API_ENDPOINT}/managers`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `JWTToken ${usr.token}`,
            },
            body: JSON.stringify(editedData),
          })
            .then((response) => response.json())
            .then((responseJson) => {
              // The added/edited data will be saved in the Grid
              if (responseJson && responseJson.response && responseJson.response !== 'OK') {
                DialogUtility.alert(responseJson.response);
                args.cancel = true;
              }
              if (responseJson && responseJson._id) {
                args.data._id = responseJson._id;
              }
              setReload(!reload);
            })
            .catch((error) => {
              args.cancel = true;
            });
        } else {
          args.cancel = true;
          setReload(!reload);
        }
      }
    } else if (args.requestType === 'save' && args.form && args.action === 'edit') {
      if (args.data) {
        // The default edit operation is cancelled
        // Here you can send the updated data to your server using AJAX call

        orgData.forEach((element) => {
          if (element.id === editedData.organizationid) {
            editedData.organizationid = element.id;
            editedData.organization = element.value;
          }
        });
        const names = [];
        associateDatasource.forEach((element) => {
          if (editedData.associates.includes(element._id)) {
            names.push(element.name);
          }
        });
        editedData.associatenames = names;
        fetch(`${REACT_APP_API_ENDPOINT}/managers`, {
          method: 'UPDATE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(editedData),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            // The added/edited data will be saved in the Grid
            if (responseJson && responseJson.response && responseJson.response !== 'OK') {
              args.cancel = true;
              DialogUtility.alert(responseJson.response);
            }
            setReload(!reload);
            // window.location.reload();
          })
          .catch((error) => {
            args.cancel = true;
          });
      }
    } else if (args.requestType === 'delete') {
      let entry = ' this entry?';
      if (args.data.length > 1) {
        entry = ' these entries?';
      }
      if (args.data) {
        // The default edit operation is cancelled
        // Here you can send the updated data to your server using AJAX call
        fetch(`${REACT_APP_API_ENDPOINT}/managers`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(editedData),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            // The added/edited data will be saved in the Grid
            if (responseJson && responseJson.response && responseJson.response !== 'OK') {
              args.cancel = true;
              DialogUtility.alert(responseJson.response);
            }
            setReload(!reload);
          })
          .catch((error) => {
            args.cancel = true;
          });
      }
    }
  };
  function setUserPreferences(pref, val) {
    if (!data.user.preferences) {
      data.user.preferences = {};
    }
    if (!data.user.preferences.managers) {
      data.user.preferences.managers = {};
    }
    if (pref === 'group') {
      data.user.preferences.managers = { group: val, sort: data.user.preferences.managers.sort };
    } else if (pref === 'sort') {
      data.user.preferences.managers = { group: data.user.preferences.managers.group, sort: val };
    }
    // Remove the New Password to avoid creating a new password
    data.user.newPassword = '';
    // Avoid Password comparison
    data.user.password = '';
    if (data.user.lastLogin && data.user.lastLogin === '') {
      data.user.lastLogin = '1970-01-01T00:00:00.000Z';
    }

    fetch(`${REACT_APP_API_ENDPOINT}/user`, {
      method: 'UPDATE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(data.user),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson && responseJson.response && responseJson.response !== 'OK') {
          DialogUtility.alert(responseJson.response);
        }
      })
      .catch(() => {
      });
  }
  const actionBegin = (args) => {
    if (args.requestType === 'ungrouping' || args.requestType === 'grouping') {
      const index = groups.indexOf(args.columnName);
      if (index > -1 && args.requestType === 'ungrouping') { // only splice array when item is found
        groups.splice(index, 1); // 2nd parameter means remove one item only
      } else if (index === -1 && args.requestType === 'grouping') { // only splice array when item is found
        groups.push(args.columnName); // 2nd parameter means remove one item only
      }
      setUserPreferences('group', groups);
    } else if (args.requestType === 'sorting') {
      setUserPreferences('sort', [{ field: args.columnName, direction: args.direction }]);
    }

    if (grid && grid.current.columns) {
      const cols = grid.current.columns;
      for (const col of cols) {
        if (args.requestType === 'add') {
          if (col.headerText === 'Associates' || col.headerText === 'ID' || col.headerText === 'Image') {
            col.visible = false;
          }
        }
      }
    }
  };
  if (!data.role.associates.permissions.includes('Read')) {
    return <p>Not authorized...</p>;
  }
  const editing = {
    allowEditing: crudUpdate,
    allowAdding: crudCreate,
    allowDeleting: crudDelete,
    showConfirmDialog: true,
    showDeleteConfirmDialog: true,
    mode: 'Dialog',
  };
  function onFileUpload(args) {
    // add addition data as key-value pair.
    const result = orgData.find(({ id }) => id === selUploadOrganization);
    if (!result || !result.value || result.value === '') {
      DialogUtility.alert('Invalid Organization');
      args.cancel = true;
      return;
    }
    if (!confirm(`Upload to ${result.value}`)) {
      args.cancel = true;
      return;
    }
    args.customFormData = [{ organizationid: selUploadOrganization }];
  }
  function completeUpload(args) {
    window.location.reload();
  }
  let uploadObj;
  const path = {
    removeUrl: `${REACT_APP_API_ENDPOINT}/managersremove`,
    saveUrl: `${REACT_APP_API_ENDPOINT}/managersupload`,
  };
  const buttons = { browse: 'Choose File', clear: 'Clear All', upload: 'Upload All' };

  const FilterOptions = {
    type: 'Menu',
  };
  return (
    <div className="m-2 md:m-1 mt-2 p-1 md:p-1 bg-white rounded-3xl zackat-divalh">
      <Header category="" title="Manager" />
      <div id="droparea">
        {crudCreate && (
        <div className="control-section accordion-control-section" style={{ width: '45%' }}>
          <div className="control Accordion-sample" style={{ margin: '25px 0' }}>
            <AccordionComponent>
              <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-8">
                <div className="e-input-group">
                  <div className="mt-4"> Import </div>
                </div>
                <div className="mt-2 e-input-group">
                  <div>
                    <DropDownListComponent id="ddlelement" cssClass="e-outline" dataSource={organizations.params.dataSource} fields={organizations.params.fields} placeholder="Select Organization" value={selUploadOrganization} onChange={(v) => { setUploadOrganization(v.value); }} />
                  </div>

                  <UploaderComponent
                    id="fileupload"
                    type="file"
                    ref={(uplaod) => { uploadObj = uplaod; }}
                    asyncSettings={path}
                    buttons={buttons}
                    multiple={false}
                    actionComplete={completeUpload}
                    autoUpload={false}
                    uploading={onFileUpload}
                    allowedExtensions=".csv"
                  />
                </div>
              </div>
            </AccordionComponent>
          </div>
        </div>
        )}
      </div>
      <div className="flex" height="300px">
        <GridComponent
          dataSource={data.managers}
          enableHover={false}
          allowPaging
          pageSettings={{ pageCount: 5 }}
          toolbar={toolbarOptions}
          editSettings={editing}
          allowSorting
          width="45%"
          allowResizing
          allowFiltering={data && data.managers && data.managers.length > 0}
          filterSettings={FilterOptions}
          actionComplete={actionComplete}
          actionBegin={actionBegin}
          allowGrouping
          allowPdfExport
          allowExcelExport
          groupSettings={groupOptions}
          sortSettings={sortOptions}
          allowTextWrap
          recordClick={rowClicked}
          toolbarClick={clickHandler}
          ref={grid}
        >
          <ColumnsDirective>
            {/* eslint-disable-next-line react/jsx-props-no-spreading */}
            <ColumnDirective
              field="_id"
              headerText="ID"
              width="100"
              format="C2"
              visible={false}
              textAlign="Left"
              isPrimaryKey
            />
            <ColumnDirective
              field="first"
              headerText="First"
              width="120"
              textAlign="Left"
              validationRules={valuerules}
            />
            <ColumnDirective
              field="last"
              headerText="Last"
              width="120"
              textAlign="Left"
              validationRules={valuerulesnot}
            />
            <ColumnDirective
              field="organizationid"
              headerText="Organization"
              width="100"
              textAlign="Left"
              editType="dropdownedit"
              validationRules={valuerules}
              visible
              foreignKeyField="_id"
              foreignKeyValue="title"
              dataSource={organizations.params.dataSource}
            />
          </ColumnsDirective>
          <Inject services={[Page, Selection, Toolbar, Edit, Sort, Filter, Search, Resize, ForeignKey, LazyLoadGroup, Group, PdfExport, ExcelExport]} />
        </GridComponent>
        {managerid !== ''
              && (
                <div className="m-2 md:m-1 mt-2 p-1 md:p-1 bg-white rounded-3xl zackat-divalh">
                  {managerid !== 'add_manager' ? <h1>Edit Manager</h1> : <h1>Add Manager</h1>}
                    {managerid !== 'add_manager' && (
                    <div className="control-section accordion-control-section">
                      <div className="control Accordion-sample" style={{ margin: '25px 0' }}>
                        <AccordionComponent multiple>
                          <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-8">
                            <div className="e-input-group">
                              <div className="mt-4"> Associates </div>
                            </div>
                            <div>
                              <TextBoxComponent multiline htmlAttributes={multilineAttributes} value={selAssociates} title="associates assigned" readOnly floatLabelType="Never" onChange={() => { }} />
                            </div>
                          </div>
                        </AccordionComponent>
                        <div className="e-input-group">
                          <TextBoxComponent placeholder="Enter Associates Name" value={selAnAssociate} required showClearButton cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setAnAssociate(v.value); }} />
                          <ButtonComponent cssClass="e-info" onClick={lookupAssociate}>Add</ButtonComponent>
                          <ButtonComponent cssClass="e-danger" onClick={removeAssociate}>Remove</ButtonComponent>
                        </div>
                      </div>
                    </div>
                    )}
                  <form>
                    {managerid !== 'add_manager' && (
                    <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2">
                      <div className="e-input-group">
                        <img src={selEmployeeImage} className="w-10 h-10" value={selFirstName} id={managerid} />
                        <input type="file" name="userfile" id={managerid} onChange={handleChange} />
                      </div>
                    </div>
                    )}
                    <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2">
                      <div className="e-input-group">
                        <TextBoxComponent placeholder="Enter First Name" value={selFirstName} required showClearButton cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setFirstName(v.value); }} />
                        <TextBoxComponent placeholder="Enter Last Name" value={selLastName} required showClearButton cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setLastName(v.value); }} />
                      </div>
                    </div>

                    <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2">
                      <div className="e-input-group">
                        <TextBoxComponent placeholder="Enter Address" value={selAddress} showClearButton cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setAddress(v.value); }} />
                      </div>
                    </div>
                    <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2">
                      <div className="e-input-group">
                        <TextBoxComponent placeholder="Enter Address cont." value={selAddress1} showClearButton cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setAddress1(v.value); }} />
                      </div>
                    </div>

                    <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2">
                      <div className="e-input-group">
                        <TextBoxComponent placeholder="Enter City" value={selCity} showClearButton cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setCity(v.value); }} />
                      </div>
                    </div>
                    <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2">
                      <div className="e-input-group">
                        <TextBoxComponent placeholder="Enter State" value={selState} showClearButton cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setState(v.value); }} />
                      </div>
                    </div>
                    <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2">
                      <div className="e-input-group">
                        <TextBoxComponent placeholder="Enter Zip" value={selZip} showClearButton cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setZip(v.value); }} />
                      </div>
                    </div>
                    <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2">
                      <div className="e-input-group">
                        <TextBoxComponent placeholder="Mobile" value={selMobile} type="text" showClearButton cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setMobile(v.value); }} />
                        <TextBoxComponent placeholder="Email Address" value={selEmail} type="email" showClearButton cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setEmail(v.value); }} />
                      </div>
                    </div>
                    <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2">
                      <div className="e-input-group">
                        <CheckBoxComponent label="SMS OpIin" title="Controlled via mobile App" disabled checked={smsOptin} />
                        <CheckBoxComponent label="Email OptIn" title="Controlled via mobile App" disabled checked={emailOptin} />
                      </div>
                    </div>
                    <div className="row custom-margin">
                      <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6">
                        <div className="e-input-group">
                          <DropDownListComponent id="ddlelement" cssClass="e-outline" dataSource={organizations.params.dataSource} fields={organizations.params.fields} placeholder="Select Organization" value={selOrganization} onChange={(v) => { setOrganization(v.value); }} />
                        </div>
                      </div>
                    </div>
                  </form>
                  {managerid !== 'add_manager' && (
                    <div className="col-xs-12 col-sm-12 col-lg-6 col-md-6">
                      <ButtonComponent cssClass="e-warning" onClick={cancelProfile}>Cancel</ButtonComponent>
                      {crudUpdate && <ButtonComponent style={{ float: 'right' }} cssClass="e-info" onClick={saveProfile}>Save</ButtonComponent>}
                    </div>
                  )}
                  {managerid === 'add_manager' && (
                    <div className="col-xs-12 col-sm-12 col-lg-6 col-md-6">
                      <ButtonComponent cssClass="e-warning" onClick={cancelProfile}>Cancel</ButtonComponent>
                      {crudCreate && <ButtonComponent style={{ float: 'right' }} cssClass="e-success" onClick={addProfile}>Add</ButtonComponent>}
                    </div>
                  )}
                </div>
              )}
      </div>
      <DialogComponent ref={dialogRef} header="Associate Action" content={associateContent} showCloseIcon width="300px" buttons={dialogButtons} visible={false} />
    </div>
  );
};

export default Manager;
